import { infrastructuresRepo } from '@/constants/providers';
import { AutomationKey } from '@/modules/Automations/queries/keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { InfrastructureCostKey } from './types';

export const useDisassociateAutomationInfrastructureCost = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      automationId,
      infrastructureCostId,
    }: {
      automationId: number;
      infrastructureCostId: number;
    }) =>
      infrastructuresRepo.disassociateAutomationInfrastructureCost(
        automationId,
        infrastructureCostId,
      ),
    onError: () => {
      toast.error(t('error.disassociate_automation_infrastructure_cost'));
    },
    onSuccess: () => {
      queryClient.invalidateQueries(AutomationKey.ALL);
      queryClient.invalidateQueries(InfrastructureCostKey.ALL);
      toast.success(t('success_disassociate_automation_infrastructure_cost'));
    },
  });
};
